import genderEnum from "@/config/genderEnum"

import hasAccomodations, {IHasAccomodations} from './mixins/Accomodation/hasAccomodations';
import hasServicesEligible, {IHasServicesEligible} from '@/model/mixins/Service/hasServicesEligible';
import hasServicesIncluded, {IHasServicesIncluded} from '@/model/mixins/Service/hasServicesIncluded';
import hasServicesSelected, {IHasServicesSelected} from '@/model/mixins/Service/hasServicesSelected';
import hasServiceFamiliesSelected, {IHasServiceFamiliesSelected} from "@/model/mixins/ServiceFamily/hasServiceFamiliesSelected";
import hasInsurancesEligible, {IHasInsurancesEligible} from '@/model/mixins/Insurance/hasInsurancesEligible';
import hasInsurancesIncluded, {IHasInsurancesIncluded} from '@/model/mixins/Insurance/hasInsurancesIncluded';
import hasInsurancesSelected, {IHasInsurancesSelected} from '@/model/mixins/Insurance/hasInsurancesSelected';
import hasInsuranceFamiliesSelected, {IHasInsuranceFamiliesSelected} from "@/model/mixins/InsuranceFamily/hasInsuranceFamiliesSelected";
import hasBaseTravellerQuoteObject, {IHasBaseTravellerQuoteObject} from "@/model/mixins/hasBaseTravellerQuoteObject"



class TravellerBase {
    protected id: string
    protected type: string
    protected birthday: string
    protected firstName = ''
    protected lastName = ''
    protected age = 18
    protected gender: genderEnum = genderEnum.None
    protected index = NaN

    constructor(
        id: string,
        type: string,
        birthday: string,
        age = 18,
        firstName = '',
        lastName = '',
        gender = genderEnum.None,
    ) {
        this.id = id
        this.type = type
        this.birthday = birthday
        this.age = age
        this.firstName = firstName
        this.lastName = lastName
        this.gender = gender
    }

    public setIndex(index: number): void  {
        this.index = index
    }
    public getIndex(): number {
        return this.index
    }
    public getId(): string {
        return this.id
    }
    public getType(): string {
        return this.type
    }
    public getBirthday(): string {
        return this.birthday
    }
    public getFirstName(): string {
        return this.firstName
    }
    public setFirstName(firstName: string): void {
        this.firstName = firstName
    }
    public getLastName(): string {
        return this.lastName
    }
    public setLastName(lastName: string): void {
        this.lastName = lastName
    }
    public getAge(): number {
        return this.age
    }
    public setAge(age: number): void {
        this.age = age
    }
    public getGender(): genderEnum {
        return this.gender
    }
    public setGender(gender: genderEnum): void {
        this.gender = gender
    }

}

export interface ITraveller extends TravellerBase, IHasAccomodations, IHasInsurancesIncluded, IHasServicesIncluded, IHasServicesSelected, IHasServicesEligible, IHasBaseTravellerQuoteObject, IHasServiceFamiliesSelected, IHasInsurancesEligible, IHasInsurancesSelected, IHasInsuranceFamiliesSelected {
    setIndex(index: number): void
    getIndex(): number
    getId(): string
    getType(): string
    getBirthday(): string
    getFirstName(): string
    setFirstName(firstName: string): void
    getLastName(): string
    setLastName(lastName: string): void
    getAge(): number
    setAge(age: number): void
    getGender(): genderEnum
    setGender(gender: genderEnum): void
}


// apply mixins
const Traveller: Constructor<ITraveller> = hasInsurancesIncluded(hasServicesIncluded(hasBaseTravellerQuoteObject(hasInsuranceFamiliesSelected(hasInsurancesSelected(hasInsurancesEligible(hasAccomodations(hasServicesEligible(hasServiceFamiliesSelected(hasServicesSelected(TravellerBase))))))))))

export default Traveller